import { createUseStyles } from '@glu/theming';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '&:first-child': {
      marginBottom: 24,
    },
    '&:last-child': {
      margin: 0,
    },
  },
  action: {
    '&:first-child': {
      margin: 0,
    },
    marginLeft: 16,
  },
};

export default createUseStyles(styles);
